import React from 'react';

import StandaloneHeader from './standAloneHeader.js';

const StandaloneHeaderPage: React.FC = () => {
  return <StandaloneHeader />;
};

export default StandaloneHeaderPage;
